import { BrowserRouter } from "react-router-dom";
import AppRoutes from "./routes";
import { useEffect, useState } from "react";
import { Modal, Text, Title } from "@mantine/core";

// styles
import "bulma/css/bulma.css"; //styling removes basic styles for headers etc
import "./static/css/styles.css";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap-icons/font/bootstrap-icons.css";
import "antd/dist/antd.css";

import { QueryClientProvider, QueryClient } from "react-query";
import { ReactQueryDevtools } from "react-query/devtools";
import { putLogOut } from "./helpers/api";
import { SocketProvider } from "./contexts/SocketContext";
import { AppointmentNotificationHandler } from "./components/shared/appointment-notifications";

import posthog from "posthog-js";

// initializations
const queryClient = new QueryClient();
posthog.init(process.env.REACT_APP_POSTHOG_KEY, {
  api_host: "https://us.i.posthog.com",
  person_profiles: "identified_only", // or 'always' to create profiles for anonymous users as well
});

// app
function App() {
  const [showAnniversaryModal, setShowAnniversaryModal] = useState(false);

  useEffect(() => {
    const anniversarySeen = sessionStorage.getItem("rivia-anniversary-seen");
    if (!anniversarySeen) {
      setShowAnniversaryModal(true);
      sessionStorage.setItem("rivia-anniversary-seen", "true");
    }
  }, []);

  window.onclose = () => putLogOut();

  return (
    <BrowserRouter>
      <QueryClientProvider client={queryClient}>
        <SocketProvider>
          <Modal
            opened={showAnniversaryModal}
            onClose={() => setShowAnniversaryModal(false)}
            centered
            styles={{
              modal: { backgroundColor: "#000000" },
              header: { backgroundColor: "#000000" },
              body: { backgroundColor: "#000000" },
            }}
            withCloseButton
            title={
              <Title order={2} className="anniversary-title mb-0">
                Anniversary Edition
              </Title>
            }>
            <Text className="anniversary-body">
              welcome to the anniversary edition of CareOS. This is the beginning of a new era for CareOS
            </Text>
          </Modal>
          <AppointmentNotificationHandler />
          <AppRoutes />
          <ReactQueryDevtools initialIsOpen={false} />
        </SocketProvider>
      </QueryClientProvider>
    </BrowserRouter>
  );
}

export default App;
